<div>
  <canvas id="canvas">{{ chart }}</canvas>
</div>
